function getMin<T, K extends keyof T>(array: Array<T>, attribute: K): T {
    return array.reduce((prev, curr) => prev[attribute] < curr[attribute] ? prev : curr);
}

function getMax<T, K extends keyof T>(array: Array<T>, attribute: K): T {
    return array.reduce((prev, curr) => prev[attribute] > curr[attribute] ? prev : curr);
}

export { getMin, getMax };
